export const createMessagiVocaliDataInitialState = {
  data: {
    destinationTypes: [],
    fdnList: [],
    fdnGroupList: [],
    vocalMessagesList: [],
    odrList: [],
    tdrList: [],
    barringList: [],
    messagiVocaliSuBaseOrigineList: [],
    whiteList: [],
    menuServiceList: [],
    nedList: [],
    fileAudioList: [],
    currentItemList: [],
  },
  loading: false,
};

export const currentMessagiVocali = {
  data: {
    nome: "",
    announcementId: "",
    destinationType: "",
    destinationId: "",
    regoleDiApplicazioneId: "",
  },
  loading: false,
};
